// extracted by mini-css-extract-plugin
export var active = "_hs-7";
export var blink = "_hs-8";
export var dropDownSelector = "_hs-4";
export var dropDownWrapper = "_hs-3";
export var fakeCursor = "_hs-6";
export var fontSizeButton = "_hs-9";
export var formQuillEditor = "_hs-0";
export var pressed = "_hs-a";
export var qlBlank = "_hs-1";
export var textFormattingToolbar = "_hs-2";
export var textToolbarOption = "_hs-5";